export default __webpack_public_path__ + "static/media/brand-logo-for-dark-background.1c714452.png";